export const MENU_ITEM = {
  TIMELINE:    "menuItem:share:timeline",
  APP_MESSAGE: "menuItem:share:appMessage"
}

export default (
  [
    "menuItem:share:qq",
    "menuItem:share:weiboApp",
    "menuItem:share:facebook",
    "menuItem:share:email",
    "menuItem:share:QZone",
    "menuItem:editTag",
    "menuItem:delete",
    "menuItem:originPage",
    "menuItem:openWithSafari",
    "menuItem:openWithQQBrowser",
    "menuItem:copyUrl",
    "menuItem:readMode",
    "menuItem:setFont",
    "menuItem:exposeArticle"
  ]
)
